import "./ThreeDotsLoadingSpinner.css";

interface ILoadingSpinnerProps {
  className?: string;
  style?: React.CSSProperties;
}
const ThreeDotsLoadingSpinner: React.FC<ILoadingSpinnerProps> = ({ className, style }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className={className} style={style}>
      <circle className="spinner_b2T7" cx="4" cy="12" r="3" />
      <circle className="spinner_b2T7 spinner_YRVV" cx="12" cy="12" r="3" />
      <circle className="spinner_b2T7 spinner_c9oY" cx="20" cy="12" r="3" />
    </svg>
  );
};

export default ThreeDotsLoadingSpinner;